module.exports = __webpack_public_path__ + "img/db798f89c06ee1b12df08b61345cafd9.png";